var render = function (_h,_vm) {var _c=_vm._c;return _c('img',_vm._g(_vm._b({staticClass:"logo",class:[_vm.data.class, _vm.data.staticClass],attrs:{"src":require("@/assets/logo.png"),"alt":"","role":"presentation"}},'img',_vm.data.attrs,false),_vm.data.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }